import React from "react";

import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

// Bootstrap components
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Form as BootstrapForm, Button } from "react-bootstrap";

// Custom Styles
import "./contactForm.styles.scss";

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Name is too short")
    .max(50, "Name is too long")
    .required("Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  phoneNumber: Yup.string()
    .matches(/^\d{10}$/, "Phone number must be 10 digits")
    .required("Phone number is required"),
  curso: Yup.string().required("Please select a course"),
});

function ContactForm() {
  return (
    <div className="contact-form">
      <Container fluid>
        <h6 className="contact-form__intro">Contáctanos</h6>
        <h4>
          Simplemente rellene el formulario de contacto y le responderemos en
          breve.
        </h4>
        <p>
          But I must explain to you how all this mistaken idea of denouncing
          pleasure and praising pain was born and I will give you a complete
          account of the system, and expound the actual teachings of the great
          explorer of the truth.
        </p>
        <Formik
          initialValues={{
            name: "",
            email: "",
            phoneNumber: "",
            curso: "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting }) => {
            console.log(values);
            setSubmitting(false);
          }}
        >
          {({ isSubmitting }) => (
            <Form as={BootstrapForm}>
              <Row>
                <BootstrapForm.Group
                  as={Col}
                  xs="12"
                  xl="3"
                  controlId="formName"
                  className="mt-3 mt-lg-0"
                >
                  <BootstrapForm.Label>Nombre completo:</BootstrapForm.Label>
                  <Field
                    name="name"
                    as={BootstrapForm.Control}
                    type="text"
                    placeholder="Escribe tu nombre"
                  />
                  <ErrorMessage
                    name="name"
                    component="div"
                    className="text-danger"
                  />
                </BootstrapForm.Group>

                <BootstrapForm.Group
                  as={Col}
                  xs="12"
                  xl="3"
                  controlId="formEmail"
                  className="mt-3 mt-lg-0"
                >
                  <BootstrapForm.Label>Email:</BootstrapForm.Label>
                  <Field
                    name="email"
                    as={BootstrapForm.Control}
                    type="email"
                    placeholder="Escrive tu email"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="text-danger"
                  />
                </BootstrapForm.Group>
                <BootstrapForm.Group
                  as={Col}
                  xs="12"
                  xl="3"
                  controlId="formPhoneNumber"
                  className="mt-3 mt-lg-0"
                >
                  <BootstrapForm.Label>No. de teléfono:</BootstrapForm.Label>
                  <Field
                    name="phoneNumber"
                    as={BootstrapForm.Control}
                    type="text"
                    placeholder="Escribe tu número de teléfono"
                  />
                  <ErrorMessage
                    name="phoneNumber"
                    component="div"
                    className="text-danger"
                  />
                </BootstrapForm.Group>

                <BootstrapForm.Group
                  as={Col}
                  xs="12"
                  xl="3"
                  controlId="formCurso"
                  className="mt-3 mt-lg-0"
                >
                  <BootstrapForm.Label>
                    Estoy interesada/o en:
                  </BootstrapForm.Label>
                  <Field name="curso" as="select">
                    <option value="">Selecciona curso</option>
                    <option value="curso1">Curso 1</option>
                    <option value="curso2">Curso 2</option>
                  </Field>
                  <ErrorMessage
                    name="curso"
                    component="div"
                    className="text-danger"
                  />
                </BootstrapForm.Group>
              </Row>

              <Button type="submit" disabled={isSubmitting}>
                Enviar información
              </Button>
            </Form>
          )}
        </Formik>
      </Container>
    </div>
  );
}

export default ContactForm;
